// Utility functions for date formatting in Brazilian format

/**
 * Convert date from YYYY-MM-DD to DD/MM/YYYY
 */
export const formatDateBR = (dateString) => {
  if (!dateString) return '';
  
  try {
    // If already in Brazilian format, return as is
    if (dateString.includes('/')) return dateString;
    
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  } catch (error) {
    return dateString;
  }
};

/**
 * Convert date from DD/MM/YYYY to YYYY-MM-DD
 */
export const formatDateISO = (dateString) => {
  if (!dateString) return '';
  
  try {
    // If already in ISO format, return as is
    if (dateString.includes('-') && dateString.indexOf('-') === 4) return dateString;
    
    const [day, month, year] = dateString.split('/');
    return `${year}-${month}-${day}`;
  } catch (error) {
    return dateString;
  }
};

/**
 * Format datetime to Brazilian format DD/MM/YYYY HH:MM
 */
export const formatDateTimeBR = (dateTimeString) => {
  if (!dateTimeString) return '';
  
  try {
    const date = new Date(dateTimeString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  } catch (error) {
    return dateTimeString;
  }
};

/**
 * Get current date in YYYY-MM-DD format for input[type="date"]
 */
export const getCurrentDateISO = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Get current date in DD/MM/YYYY format
 */
export const getCurrentDateBR = () => {
  const date = new Date();
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
